
import { apiClient } from '@/lib/mockApi';


export const certificateService = apiClient;
